export enum ApIconType {
  ApDashboardIcon = 'ap-dashboard-icon',
  ApBaseDataIcon = 'ap-basedata-icon',
  ApUploadIcon = 'ap-upload-icon',
  ApFungiDetectIcon = 'ap-fungidetect-icon',
  ApDatabaseIcon = 'ap-database-icon',
  ApFileIcon = 'ap-file-icon',
  ApMapIcon = 'ap-map-icon',
  ApDocumentationIcon = 'ap-documentation-icon',
  ApContectIcon = 'ap-contact-icon',
  ApLegalIcon = 'ap-legal-icon',
  ApImprintIcon = 'ap-imprint-icon',
  ApAgreementIcon = 'ap-agreement-icon',
  ApExclamationCircleIcon = 'ap-exclamation-circle-icon',
  ApExclamationCircleSolidIcon = 'ap-exclamation-circle-solid-icon',
  ApCheckCircleIcon = 'ap-check-circle-icon',
  ApCheckCircleSolidIcon = 'ap-check-circle-solid-icon',
  ApTimesCircleIcon = 'ap-times-circle-icon',
  ApTimesCircleSolidIcon = 'ap-times-circle-solid-icon',
  ApBanSolidIcon = 'ap-ban-solid-icon',
  ApIconAdministration = 'ap-icon-administration',
  ApIconBaseFertilization = 'ap-icon-base-fertilization',
  ApIconBooking = 'ap-icon-booking',
  ApIconCollapse = 'ap-icon-collapse',
  ApIconEvaluation = 'ap-icon-evaluation',
  ApIconFieldWorks = 'ap-icon-field-works',
  ApIconFields = 'ap-icon-fields',
  ApIconImport = 'ap-icon-import',
  ApIconNFertilization = 'ap-icon-n-fertilization',
  ApIconPlantProtection = 'ap-icon-plant-protection',
  ApIconSeeding = 'ap-icon-seeding',
  ApIconSettings = 'ap-icon-settings',
  ApIconTasks = 'ap-icon-tasks',
  ApIconFarmRecords = 'ap-icon-farm-records',
  ApInfoIconRound = 'ap-info-icon-round'
}
